module.exports = __webpack_public_path__ + "img/mine14.c40a7547.png";